module.exports = __webpack_public_path__ + "static/media/details-4.8edaf8cb.jpeg";